import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router} from "react-router-dom";

import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

// Initialize the Google Analytics stuff
// import Tracking from './Tracking';
// Tracking.initialize('UA-17747516-4', { debug: false, app_name: 'NNpiano' });

// calculate correct virtual pixel based on real screen height and save it in a CSS variable
let vh = window.innerHeight* 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// Recalculate the --vh on load and resize events
function setScreenHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  window.scrollTo(0, document.body.scrollHeight);
}
window.addEventListener('load', setScreenHeight);
window.addEventListener('resize', setScreenHeight);

// Override scroll events by forced scroll to top after 0.5 seconds
window.addEventListener('scroll', () => window.setTimeout(() => window.scrollTo(0,0), 500));

// Now render the React app
ReactDOM.render(<Router basename={window.PUBLIC_URL}><App/></Router>, document.getElementById("root"));
registerServiceWorker();
